import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-dark py-12 px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-61">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-62">
        <div className="font-heading font-black text-2xl text-white mb-6 tracking-tight" data-id="element-63">
          ProfePack
        </div>

        <p className="text-gray-500 text-sm mb-6" data-id="element-64">
          © 2026 ProfePack. Todos los derechos reservados.
        </p>

        <div className="flex items-center gap-6 text-sm text-gray-400" data-id="element-65">
          <a href="#" className="hover:text-white transition-colors" data-id="element-66">
            Términos y condiciones
          </a>
          <span className="text-gray-700" data-id="element-67">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-68">
            Política de privacidad
          </a>
        </div>
      </div>
    </footer>;
}